import Logger from '../../../app/shared/Logger';
import { CreateCustomerPricelistCommand } from '../../queries';
import PricelistFormState, { PricelistFormResult } from './PricelistFormState';

export default class CreatePricelistFormState extends PricelistFormState {
  public async submit(productModelIds: string[] = []): Promise<PricelistFormResult> {
    this.validate();

    if (!this.isValid) {
      return { isSuccess: false };
    }

    try {
      const response = await this.client.send(
        new CreateCustomerPricelistCommand({
          name: this.name.value,
          description: this.description.value,
          productModelIds,
        }),
      );

      return { isSuccess: true, pricelist: response.pricelist };
    } catch (error) {
      Logger.exception('Creating a price list failed', error);

      return this.toFailure(error, this.translation.errors.createFailed);
    }
  }
}
